import { IAgency } from "../../../share/types/agency";
import { TermsOfUseUserStatus } from "src/share/types/termsOfUse";

// Action types
export enum AuthTypes {
    LogIn = 'LOGIN',
    CheckTOSStatus = 'CheckTOSStatus',
    LogInFailed = 'LOGINFAILED',
    LogInLoading = 'LOGINLOADING',
    RefreshLogin = 'REFRESHLOGIN',
    Default = 'DEFAULT',
    GetAgencies = 'GETAGENCIES',
    GetNotifications = 'GETNOTIFICATIONS',
    DeleteNotifications = 'DELETENOTIFICATIONS',
    LogOut = 'LOGOUT',
    TermsOfUseStatus = 'TERMSOFUSESTATUS'
}
export enum UserTypes {
    UNAUTH,
    ADMIN,
    CASEMANAGER,
    LAWENFORCEMENTAGENT
}

export enum CognitoGroups {
    ADMIN = 'Admin',
    CASEMANAGER = 'CaseManager',
    LAWENFORCEMENTAGENT = 'LawEnforcementAgent'
}
// Type that needs to be return for the actions
export interface IAuthAction {
    type: AuthTypes;
    payload: IAuthActionsPayload;
}

export interface IAuthActionsPayload {
    userType: UserTypes
    username: string;
    idToken: IToken | null;
    accessToken: IToken | null;
    refreshToken: IRefreshToken | null;
    errorMessage: string;
    loading: boolean;
    agencies: IAgency[];
    agencyCode: string;
    notifications: INotificationResponse;
    type?: string;
    lastLogin: number | null;
    termsOfUseStatus: TermsOfUseUserStatus;
}
export const defaultAuthPayload: IAuthActionsPayload = {
    username: '',
    idToken: null,
    accessToken: null,
    refreshToken: null,
    errorMessage: '',
    loading: false,
    userType: UserTypes.UNAUTH,
    agencyCode: '',
    notifications: {},
    lastLogin: null,
    agencies: [],
    termsOfUseStatus: TermsOfUseUserStatus.NoRecords
}
export interface IAuth {
    readonly idToken: IToken | null;
    readonly accessToken: IToken | null;
    readonly refreshToken: IRefreshToken | null;
    readonly username: string;
    readonly userType: UserTypes;
    readonly termsOfUseStatus: TermsOfUseUserStatus;
}

// Inmutable State
export interface IAuthState {
    readonly idToken: IToken | null;
    readonly accessToken: IToken | null;
    readonly refreshToken: IRefreshToken | null;
    readonly username: string;
    readonly userType: UserTypes;
    readonly errorMessage: string;
    readonly loading: boolean;
    readonly agencies: IAgency[];
    readonly agencyCode: string;
    readonly notifications: INotificationResponse;
    readonly lastLogin: number | null;
    readonly termsOfUseStatus: TermsOfUseUserStatus;
}

export interface IToken {
    readonly jwtToken: string;
    readonly payload: any;
}
export interface IRefreshToken {
    readonly token: string;
}
export enum NotificationType {
    Case = '0',
    Alert = '1',
    Match = '2',
    Crossborder = '3'
}
export interface INotification {
    id?: string;
    type: NotificationType;
    title: string;
    email?: string;
    subTitle: string;
    date: number;
    alertId?: string;
    searchId?: string;
    matchType?: 'adhoc' | 'child'
    caseId: string;
    childId?: string;
    imageUrl?: string;
    location?: string;
    radius?: number;
    handler: string;
    currentAgency?: string;
    targetAgency?: string;
    targetAgencyContact?: any[];
}
export interface INotificationResponse {
    [type: number]: {
        [id: string]: INotification
    }
}